ModelWithPreferences = require 'models/internal/model-with-preferences'
_ = require 'underscore'

module.exports = class ModelWithPersonalPreferences extends ModelWithPreferences
  myPrefNames: []
  myPrefDefaults: {}

  constructor: ->
    super
    @_initSubEventsOn 'myPrefs'
    return

  toJSON: (opts = {}) ->
    data = super

    if opts.prefs
      for preference in @myPrefNames
        value = @getPref(preference)
        data[preference] = value
        data["#{preference}_#{value}"] = true

    data

  getPref: (name) ->
    if name in @myPrefNames
      @get('myPrefs')?[name] ? @myPrefDefaults[name]
    else
      super

  setPref: (name, value, next) ->
    if name in @myPrefNames
      @setMyPref name, value, next
    else
      super

  setMyPref: (name, value, next) ->
    @api {
      type: 'put'
      method: "myPrefs/#{name}"
      data: { value }
    }, next

    myPrefs = _.clone(@get('myPrefs'))
    myPrefs[name] = value
    @set { myPrefs }



// WEBPACK FOOTER //
// ./app/scripts/models/internal/model-with-personal-preferences.coffee